import React, { useState } from "react";

export default function CollapsibleCard({
  icon,
  title,
  badge,
  headerRight,
  defaultOpen = false,
  onOpenChange,
  children,
}) {
  const [open, setOpen] = useState(defaultOpen);

  const toggle = () => {
    const next = !open;
    setOpen(next);
    onOpenChange?.(next);
  };

  return (
    <div className="card">
      {/* `role="button"` plutôt qu'un vrai <button> : headerRight peut contenir ses propres
          boutons interactifs (ex. "Rapport de triage" par campagne, PokEssais.jsx, 23/09/2026) —
          un <button> imbriqué dans un <button> est invalide en HTML et le comportement de clic
          devient peu fiable selon les navigateurs. */}
      <div
        role="button"
        tabIndex={0}
        onClick={toggle}
        onKeyDown={(e) => { if (e.key === "Enter" || e.key === " ") { e.preventDefault(); toggle(); } }}
        className={`w-full flex items-center gap-2 px-4 py-3 text-left hover:bg-gray-50 transition-colors cursor-pointer ${open ? "border-b border-gray-100" : ""}`}
      >
        {icon && <span className="text-base">{icon}</span>}
        <h2 className="text-sm font-semibold text-gray-700">{title}</h2>
        {badge != null && <span className="badge badge-neutral">{badge}</span>}
        {headerRight
          ? <span className="ml-auto flex items-center gap-2">{headerRight}<span className="text-gray-400 text-xs">{open ? "▲" : "▼"}</span></span>
          : <span className="ml-auto text-gray-400 text-xs">{open ? "▲" : "▼"}</span>
        }
      </div>
      {open && children}
    </div>
  );
}
